export const ColorPreview = ({color, diameter = 70, label = 'Color', code='RAL 9010', handleColorClick = null, selected = false}) => {

    return(
        <div
        key={color}
        onClick={() => handleColorClick(code)}
        className={`rounded-full cursor-pointer transform transition-all duration-200 ease-out relative ${
          selected
            ? 'shadow-[0_0_0_3px_#1f2937] scale-105'
            : 'shadow-[0_2px_8px_rgba(0,0,0,0.12)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.16)] hover:scale-105'
        }`}
        style={{ backgroundColor: color, width: diameter, height: diameter }}
        title={label}
      >
        <div className={`absolute inset-0 rounded-full pointer-events-none transition-all duration-200 ${
          selected
            ? 'ring-[3px] ring-inset ring-white shadow-inner'
            : 'ring-[1px] ring-inset ring-black/10 hover:ring-black/15'
        }`} />
      </div>
    )

}